/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DistributedRewardResponse } from './DistributedRewardResponse';
import {
    DistributedRewardResponseFromJSON,
    DistributedRewardResponseFromJSONTyped,
    DistributedRewardResponseToJSON,
    DistributedRewardResponseToJSONTyped,
} from './DistributedRewardResponse';

/**
 * 
 * @export
 * @interface GetDistributedRewardsOwnResponse
 */
export interface GetDistributedRewardsOwnResponse {
    /**
     * 
     * @type {Array<DistributedRewardResponse>}
     * @memberof GetDistributedRewardsOwnResponse
     */
    rewards: Array<DistributedRewardResponse>;
}

/**
 * Check if a given object implements the GetDistributedRewardsOwnResponse interface.
 */
export function instanceOfGetDistributedRewardsOwnResponse(value: object): value is GetDistributedRewardsOwnResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function GetDistributedRewardsOwnResponseFromJSON(json: any): GetDistributedRewardsOwnResponse {
    return GetDistributedRewardsOwnResponseFromJSONTyped(json, false);
}

export function GetDistributedRewardsOwnResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDistributedRewardsOwnResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(DistributedRewardResponseFromJSON)),
    };
}

export function GetDistributedRewardsOwnResponseToJSON(json: any): GetDistributedRewardsOwnResponse {
    return GetDistributedRewardsOwnResponseToJSONTyped(json, false);
}

export function GetDistributedRewardsOwnResponseToJSONTyped(value?: GetDistributedRewardsOwnResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(DistributedRewardResponseToJSON)),
    };
}

